module.exports = __webpack_public_path__ + "media/images/ui__infoOk--dark-84d47ce58d4472f0445afec397d03b01.png";